import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from './api.service';
import {
  ResultsDayEntryProgress,
  ResultsDayFinishResponse,
  ResultsDayLookupResponse,
  TlhResultsDayEntry,
} from '../types/results-day-types';

@Injectable({ providedIn: 'root' })
export class ResultsDayService {
  private apiService = inject(ApiService);
  baseRoute = 'tlh-results-day';

  /**
   * Fired when something outside the modal (e.g. a campaign iframe's
   * postMessage) wants a specific results day opened on demand — the
   * globally-mounted ResultsDayModalComponent subscribes to this.
   */
  private openRequests$ = new Subject<number>();
  readonly openRequests = this.openRequests$.asObservable();

  requestOpen(resultsDayId: number): void {
    this.openRequests$.next(resultsDayId);
  }

  getById(resultsDayId: number): Observable<ResultsDayLookupResponse> {
    return this.apiService.request<ResultsDayLookupResponse>('GET', `${this.baseRoute}/${resultsDayId}`);
  }

  start(resultsDayId: number): Observable<TlhResultsDayEntry> {
    return this.apiService.request<TlhResultsDayEntry>('POST', `${this.baseRoute}/${resultsDayId}/start`);
  }

  saveEntry(resultsDayId: number, progress: ResultsDayEntryProgress): Observable<TlhResultsDayEntry> {
    return this.apiService.request<TlhResultsDayEntry>('PUT', `${this.baseRoute}/${resultsDayId}/entry`, progress);
  }

  finish(resultsDayId: number): Observable<ResultsDayFinishResponse> {
    return this.apiService.request<ResultsDayFinishResponse>('POST', `${this.baseRoute}/${resultsDayId}/finish`);
  }

  decline(resultsDayId: number): Observable<TlhResultsDayEntry> {
    return this.apiService.request<TlhResultsDayEntry>('POST', `${this.baseRoute}/${resultsDayId}/decline`);
  }
}
